import React from 'react';
import VideoCard from '../../../components/VideoCard';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Link } from 'react-router-dom';

const HallOfFameSection = ({ topContent, onWhatsAppRequest }) => {
  if (topContent?.length === 0) {
    return null;
  }

  return (
    <div className="w-full bg-gradient-to-br from-card via-muted to-card rounded-lg p-6 md:p-8 lg:p-10 glow-accent">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-accent/20 rounded-full flex items-center justify-center glow-accent">
            <Icon name="Award" size={24} color="var(--color-accent)" />
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground">
              Hall da Fama
            </h2>
            <p className="text-sm md:text-base text-muted-foreground">
              Nossos conteúdos mais bem avaliados
            </p>
          </div>
        </div>

        <Link to="/hall-of-fame">
          <Button variant="outline" size="default" iconName="ArrowRight" iconPosition="right">
            Ver Todos
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {topContent?.slice(0, 3)?.map((content, index) => (
          <div key={content?.id} className="relative">
            <div className="absolute top-3 left-3 z-10 w-10 h-10 md:w-12 md:h-12 bg-accent rounded-full flex items-center justify-center font-heading font-bold text-lg md:text-xl text-background glow-accent">
              {index + 1}
            </div>
            <VideoCard
              content={content}
              onWhatsAppRequest={onWhatsAppRequest}
              variant="default"
              onContentClick={() => {}}
              onRatingChange={() => {}}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HallOfFameSection;